import { connect } from 'react-redux';
import { Sidebar } from './Sidebar';
import {
  resetViewCipGeneration,
  resetViewCipReport,
} from '@app/src/commons/sidebar/state/sidebar/actions';
import { userLogout } from '@app/src/views/Login/login/state/login/actions';

const mapDispatchToProps = dispatch => ({
  resetViewCipGeneration: () => dispatch(resetViewCipGeneration()),
  resetViewCipReport: () => dispatch(resetViewCipReport()),
  logout: (history) => dispatch(userLogout(history))
});

export const SidebarContainer = connect(
  null,
  mapDispatchToProps
)(Sidebar);
